import { AboutUsView } from "~landing/views/about-us";
import { NextPage } from "next";
import { MarketingSeo } from "~landing/seo/marketing-seo";
import { useEffect } from "react";
import { sendPublicPageViewEvent } from "~tag-manager/send-event";

const AboutUsPage: NextPage = () => {
	useEffect(() => {
		sendPublicPageViewEvent({ page_category: "utility" });
	}, []);

	return (
		<>
			<MarketingSeo
				path="/about-us"
				title="About Us"
			/>
			<AboutUsView />
		</>
	);
};

export default AboutUsPage;
